/*! Fire & Flame – Conversion-Layer v1 (10.10.2026)
   Warenkorb-Drawer, Paket-Upgrade, Schnellkauf, Lieferdatum.
   Abhängigkeiten: sections/ff-cart-drawer.liquid, snippets/ff-cart-content.liquid, assets/ff-cro.css */
(function () {
  'use strict';
  if (window.FFCRO) return;

  var SECTION = 'ff-cart-drawer';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;
  var lastFocus = null;
  var noticeTimer = null;
  var refreshTimer = null;

  function qs(s, c) { return (c || document).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function drawer() { return document.getElementById('ff-cart-drawer'); }
  function isCartPage() { return /\/cart\/?$/.test(window.location.pathname); }
  function route(path) { return ROOT + String(path).replace(/^\//, ''); }
  function lower(s) { return String(s || '').toLowerCase(); }
  function shortName(t) { return String(t || '').split(' – ')[0].trim(); }

  /* ---------- Requests & Rendering ---------- */
  function sectionIds() {
    var ids = [];
    if (drawer()) ids.push(SECTION);
    qsa('.ffcc--page[data-ff-sid]').forEach(function (el) {
      var id = el.getAttribute('data-ff-sid');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function parse(r) {
    return r.text().then(function (txt) {
      var j = {};
      try { j = txt ? JSON.parse(txt) : {}; } catch (e) { j = {}; }
      if (!r.ok) {
        var err = new Error((j && (j.description || j.message)) || ('HTTP ' + r.status));
        err.data = j;
        err.status = r.status;
        throw err;
      }
      return j;
    });
  }

  function post(path, body, withSections) {
    var ids = withSections === false ? [] : sectionIds();
    var opts = { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      if (ids.length) { body.append('sections', ids.join(',')); body.append('sections_url', window.location.pathname); }
      opts.body = body;
    } else {
      body = body || {};
      if (ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return window.fetch(route(path), opts).then(parse);
  }

  function render(sections) {
    if (!sections) return false;
    var parser = new DOMParser();
    var done = false;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var incoming = qs('[data-ff-cart-content]', parser.parseFromString(html, 'text/html'));
      if (!incoming) return;
      var current = id === SECTION ? qs('#ff-cart-drawer [data-ff-cart-content]') : qs('.ffcc--page[data-ff-sid="' + id + '"]');
      if (!current) return;
      current.replaceWith(document.adoptNode(incoming));
      done = true;
    });
    return done;
  }

  function afterRender() {
    var c = qs('#ff-cart-drawer [data-ff-cart-content]') || qs('[data-ff-cart-content]');
    if (c) {
      var n = parseInt(c.getAttribute('data-cart-count'), 10) || 0;
      var total = parseInt(c.getAttribute('data-cart-total'), 10) || 0;
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: { item_count: n, total_price: total } } }));
      qsa('a.ff-header__cart').forEach(function (a) { a.setAttribute('aria-label', 'Warenkorb mit ' + n + (n === 1 ? ' Artikel' : ' Artikeln')); });
    }
    refreshDelivery();
    upgradeState();
    applyCountry(storedCountry());
  }

  function refresh() {
    var ids = sectionIds();
    if (!ids.length) return Promise.resolve();
    return window.fetch(window.location.pathname + '?sections=' + encodeURIComponent(ids.join(',')) + '&ff=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(parse)
      .then(function (s) { render(s); afterRender(); })
      .catch(function () {});
  }

  function setBusy(el, on) {
    if (!el || !el.classList) return;
    el.classList.toggle('is-busy', !!on);
    if (on) el.setAttribute('aria-busy', 'true'); else el.removeAttribute('aria-busy');
    if ('disabled' in el) el.disabled = !!on;
  }

  /* ---------- Hinweise ---------- */
  function notice(msg, type) {
    qsa('[data-ff-cart-notice]').forEach(function (n) {
      n.textContent = msg;
      n.classList.toggle('is-error', type === 'error');
      n.classList.add('is-visible');
    });
    window.clearTimeout(noticeTimer);
    noticeTimer = window.setTimeout(function () {
      qsa('[data-ff-cart-notice]').forEach(function (n) { n.classList.remove('is-visible'); });
    }, type === 'error' ? 9000 : 5000);
  }

  function errorText(err) {
    var d = err && err.data;
    var m = d && (d.description || d.message);
    if (m && typeof m === 'string' && m !== 'Cart Error') return m;
    return 'Das hat leider nicht geklappt. Bitte versuch es noch einmal.';
  }

  /* ---------- Land erkennen: DE-Hinweise (D1, 24.10.2026) ---------- */
  function applyCountry(c) {
    if (!c) return;
    document.documentElement.setAttribute('data-ff-country', c);
    if (c !== 'DE') return;
    qsa('[data-ff-de-text]').forEach(function (el) {
      if (el.getAttribute('data-ff-de-done')) return;
      var txt = el.getAttribute('data-ff-de-text');
      var node = null;
      for (var i = el.childNodes.length - 1; i >= 0; i--) { if (el.childNodes[i].nodeType === 3 && el.childNodes[i].textContent.trim()) { node = el.childNodes[i]; break; } }
      if (node) node.textContent = ' ' + txt + ' '; else el.appendChild(document.createTextNode(txt));
      el.setAttribute('data-ff-de-done', '1');
    });
    qsa('[data-ff-de-only]').forEach(function (el) { el.hidden = false; });
  }
  function storedCountry() { try { return window.sessionStorage.getItem('ffCountry'); } catch (e) { return null; } }
  function detectCountry() {
    var c = storedCountry();
    if (c) { applyCountry(c); return; }
    window.fetch(route('browsing_context_suggestions.json?source=geolocation_recommendation&country%5Benabled%5D=true'), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var h = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        if (!h) return;
        try { window.sessionStorage.setItem('ffCountry', h); } catch (e) {}
        applyCountry(h);
      })
      .catch(function () {});
  }

  /* ---------- Paket-Upgrade: einmal pro Sitzung ausgeklappt, danach zu (W2, 24.10.2026) ---------- */
  var UPKEY = 'ffUpSeen';
  var upUser = null;
  function upSeen() { try { return window.sessionStorage.getItem(UPKEY) === '1'; } catch (e) { return false; } }
  function markUpSeen() { try { window.sessionStorage.setItem(UPKEY, '1'); } catch (e) {} }
  function upgradeState() {
    qsa('details[data-ff-upgrade]').forEach(function (d) {
      var want = upUser === null ? !upSeen() : upUser;
      if (d.open !== want) d.open = want;
    });
  }
  window.addEventListener('pagehide', function () { if (qs('details[data-ff-upgrade][open]')) markUpSeen(); });

  /* ---------- Drawer ---------- */
  function open() {
    var d = drawer();
    if (!d) return false;
    if (d.classList.contains('is-open')) return true;
    lastFocus = document.activeElement;
    d.hidden = false;
    d.getBoundingClientRect();
    d.classList.add('is-open');
    document.documentElement.classList.add('ffcd-lock');
    var p = qs('[data-ff-cart-panel]', d);
    if (p) window.setTimeout(function () { try { p.focus({ preventScroll: true }); } catch (e) { p.focus(); } }, 40);
    refreshDelivery();
    upgradeState();
    return true;
  }

  function close() {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    if (qs('details[data-ff-upgrade]', d)) markUpSeen();
    upUser = null;
    d.classList.remove('is-open');
    document.documentElement.classList.remove('ffcd-lock');
    window.setTimeout(function () { if (!d.classList.contains('is-open')) d.hidden = true; }, 320);
    if (lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
    lastFocus = null;
  }

  /* ---------- Warenkorb-Aktionen ---------- */
  function add(items, opts) {
    opts = opts || {};
    if (busy) return Promise.resolve(null);
    busy = true;
    setBusy(opts.button, true);
    return post('cart/add.js', { items: items }).then(function (res) {
      if (!render(res.sections)) return refresh().then(function () { return res; });
      afterRender();
      return res;
    }).then(function (res) {
      notice('✓ ' + (opts.name ? opts.name + ' ist im Warenkorb' : 'Im Warenkorb'), 'ok');
      if (opts.open !== false && !isCartPage()) open();
      return res;
    }).catch(function (err) {
      notice(errorText(err), 'error');
      if (opts.open !== false && !isCartPage()) open();
      return null;
    }).then(function (res) {
      busy = false;
      setBusy(opts.button, false);
      return res;
    });
  }

  function applyDiscount(codes, btn, code) {
    if (busy) return;
    busy = true;
    setBusy(btn, true);
    post('cart/update.js', { discount: codes.join(',') }).then(function (res) {
      render(res.sections);
      afterRender();
      if (code && Array.isArray(res.discount_codes)) {
        var ok = res.discount_codes.some(function (d) { return lower(d.code) === lower(code) && d.applicable; });
        notice(ok ? '✓ Code ' + code + ' eingelöst' : 'Der Code ' + code + ' gilt für diesen Warenkorb leider nicht.', ok ? 'ok' : 'error');
      } else if (!code) {
        notice('Code entfernt', 'ok');
      }
    }).catch(function (err) {
      notice(errorText(err), 'error');
    }).then(function () {
      busy = false;
      setBusy(btn, false);
    });
  }

  function onSubmit(e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;

    if (form.hasAttribute('data-ff-discount')) {
      e.preventDefault();
      e.stopPropagation();
      var input = form.querySelector('input[name="discount"]');
      var code = input ? input.value.trim() : '';
      if (!code) { if (input) input.focus(); return; }
      var codes = (form.getAttribute('data-codes') || '').split(',').filter(Boolean);
      if (codes.map(lower).indexOf(lower(code)) === -1) codes.push(code);
      applyDiscount(codes, form.querySelector('button[type="submit"]'), code);
      return;
    }

    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (form.hasAttribute('data-ff-native') || form.querySelector('input[type="file"]') || !drawer()) return;

    var fd = new FormData(form);
    if (!fd.get('id')) return;
    e.preventDefault();
    e.stopPropagation();
    if (busy) return;

    var submitter = e.submitter || form.querySelector('[type="submit"]');
    var label = (submitter && submitter.querySelector('[data-add-label]')) || form.querySelector('[data-add-label]');
    var oldLabel = label ? label.textContent : null;
    var extras = qsa('input[data-ff-with]:checked', form).map(function (i) {
      return { id: parseInt(i.value, 10), quantity: parseInt(i.getAttribute('data-qty') || '1', 10) || 1 };
    }).filter(function (x) { return x.id; });
    var payload = fd;
    if (extras.length) {
      var main = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) || 1 };
      var props = {};
      fd.forEach(function (val, key) {
        var m = /^properties\[(.+)\]$/.exec(key);
        if (m && typeof val === 'string') props[m[1]] = val;
      });
      if (Object.keys(props).length) main.properties = props;
      if (fd.get('selling_plan')) main.selling_plan = fd.get('selling_plan');
      payload = { items: [main].concat(extras) };
    }
    busy = true;
    setBusy(submitter, true);
    if (label) label.textContent = 'Wird hinzugefügt …';
    post('cart/add.js', payload).then(function (res) {
      if (!render(res.sections)) return refresh().then(function () { return res; });
      afterRender();
      return res;
    }).then(function (res) {
      var first = res && res.items && res.items.length ? res.items[0] : res;
      var t = first && (first.product_title || first.title);
      var more = res && res.items && res.items.length > 1 ? ' (+ ' + (res.items.length - 1) + ' weiterer Artikel)' : '';
      notice('✓ ' + (t ? shortName(t) + ' ist im Warenkorb' + more : 'Im Warenkorb'), 'ok');
      if (!isCartPage()) open();
    }).catch(function (err) {
      notice(errorText(err), 'error');
      if (!isCartPage()) open();
    }).then(function () {
      busy = false;
      setBusy(submitter, false);
      if (label && oldLabel !== null) label.textContent = oldLabel;
    });
  }

  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-ff-cart-close]')) { e.preventDefault(); close(); return; }

    var link = t.closest('a.ff-header__cart, [data-ff-open-cart], a[href="/cart"]');
    if (link && drawer() && !isCartPage() && !link.closest('[data-ff-cart-drawer]') && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) {
      e.preventDefault();
      open();
      return;
    }

    var pick = t.closest('[data-ff-pick]');
    if (pick && pick.closest('[data-ff-card-buy]')) {
      e.preventDefault();
      var box = pick.closest('[data-ff-card-buy]');
      qsa('[data-ff-pick]', box).forEach(function (p) {
        var on = p === pick;
        p.classList.toggle('is-on', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var ab = qs('[data-ff-add]', box);
      if (ab) {
        var avail = pick.getAttribute('data-available') !== 'false';
        ab.setAttribute('data-ff-add', pick.getAttribute('data-ff-pick'));
        ab.disabled = !avail;
        if (ab.classList.contains('ff-cb__add')) ab.textContent = avail ? 'In den Warenkorb' : 'Ausverkauft';
      }
      var pl = qs('[data-ff-pick-label]', box);
      if (pl) pl.textContent = pick.getAttribute('data-label') || '';
      var img = pick.getAttribute('data-img');
      var card = box.closest('[data-ff-product]') || box.closest('article') || box.parentNode;
      var im = img && card ? (qs('[data-ff-card-img]', card) || qs('a[class*="card__media"] img', card)) : null;
      if (im) { im.removeAttribute('srcset'); im.src = img; }
      return;
    }

    var addBtn = t.closest('[data-ff-add]');
    if (addBtn) {
      e.preventDefault();
      var items = null;
      var multi = addBtn.getAttribute('data-ff-add-items');
      if (multi) { try { items = JSON.parse(multi); } catch (err) { items = null; } }
      if (!items) {
        var id = parseInt(addBtn.getAttribute('data-ff-add'), 10);
        if (!id) return;
        items = [{ id: id, quantity: parseInt(addBtn.getAttribute('data-qty') || '1', 10) || 1 }];
      }
      add(items, { button: addBtn, name: addBtn.getAttribute('data-name') || '' });
      return;
    }

    var qtyBtn = t.closest('[data-ff-qty]');
    if (qtyBtn) {
      e.preventDefault();
      if (busy) return;
      var key = qtyBtn.getAttribute('data-key');
      var nq = Math.max(0, parseInt(qtyBtn.getAttribute('data-qty'), 10) || 0);
      var line = qtyBtn.closest('.ffcc-line');
      var titleEl = line ? qs('.ffcc-line__title', line) : null;
      var lineName = titleEl ? titleEl.textContent.trim() : '';
      busy = true;
      if (line) line.classList.add('is-loading');
      post('cart/change.js', { id: key, quantity: nq }).then(function (res) {
        render(res.sections);
        afterRender();
        if (nq === 0) notice(lineName ? lineName + ' wurde entfernt' : 'Artikel entfernt', 'ok');
      }).catch(function (err) {
        if (line) line.classList.remove('is-loading');
        notice(errorText(err), 'error');
      }).then(function () { busy = false; });
      return;
    }

    var ein = t.closest('[data-ff-ein-chip]');
    if (ein) {
      e.preventDefault();
      var ebox = ein.closest('[data-ff-einwaende]') || document;
      var ekey = ein.getAttribute('data-ff-ein-chip');
      var wasOpen = ein.getAttribute('aria-expanded') === 'true';
      qsa('[data-ff-ein-chip]', ebox).forEach(function (c) { c.setAttribute('aria-expanded', 'false'); });
      qsa('[data-ff-ein-panel]', ebox).forEach(function (p) { p.hidden = true; });
      if (!wasOpen) {
        ein.setAttribute('aria-expanded', 'true');
        var epn = qs('[data-ff-ein-panel="' + ekey + '"]', ebox);
        if (epn) epn.hidden = false;
        try { if (typeof window.clarity === 'function') window.clarity('event', 'einwand_' + ekey); } catch (err) {}
      }
      return;
    }

    var upSum = t.closest('.ffcc-up__sum');
    if (upSum) {
      var upd = upSum.closest('details[data-ff-upgrade]');
      if (upd) { upUser = !upd.open; if (upd.open) markUpSeen(); }
      return;
    }

    var chip = t.closest('[data-ff-scent]');
    if (chip) {
      e.preventDefault();
      var up = chip.closest('[data-ff-upgrade]');
      if (!up) return;
      qsa('[data-ff-scent]', up).forEach(function (c) {
        var on = c === chip;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var sb = qs('[data-ff-swap]', up);
      if (sb) sb.setAttribute('data-variant', chip.getAttribute('data-variant'));
      var dl = qs('[data-ff-up-delta]', up);
      if (dl && chip.getAttribute('data-delta')) dl.textContent = chip.getAttribute('data-delta');
      var sv = qs('[data-ff-up-save]', up);
      var saving = chip.getAttribute('data-saving');
      if (sv) {
        if (saving) { sv.textContent = 'spart ' + saving; sv.hidden = false; }
        else sv.hidden = true;
      }
      return;
    }

    var swap = t.closest('[data-ff-swap]');
    if (swap) {
      e.preventDefault();
      if (busy) return;
      var vid = parseInt(swap.getAttribute('data-variant'), 10);
      var sq = parseInt(swap.getAttribute('data-qty'), 10) || 1;
      var skey = swap.getAttribute('data-key');
      if (!vid || !skey) return;
      var updates = {};
      updates[skey] = 0;
      (swap.getAttribute('data-remove') || '').split('|').forEach(function (pair) {
        var i = pair.lastIndexOf(':');
        if (i < 1) return;
        var k = pair.slice(0, i);
        var n = parseInt(pair.slice(i + 1), 10);
        if (k && !isNaN(n)) updates[k] = Math.max(0, n);
      });
      busy = true;
      setBusy(swap, true);
      var swapLabel = swap.textContent;
      swap.textContent = 'Wird umgestellt …';
      post('cart/add.js', { items: [{ id: vid, quantity: sq }] }, false)
        .then(function () { return post('cart/update.js', { updates: updates }); })
        .then(function (res) {
          render(res.sections);
          afterRender();
          notice('✓ Umgestellt – dein Paket ist im Warenkorb', 'ok');
        })
        .catch(function (err) {
          notice(errorText(err), 'error');
          refresh();
        })
        .then(function () {
          busy = false;
          if (document.contains(swap)) { setBusy(swap, false); swap.textContent = swapLabel; }
        });
      return;
    }

    var rm = t.closest('[data-ff-discount-remove]');
    if (rm) {
      e.preventDefault();
      var scope = rm.closest('[data-ff-cart-content]') || document;
      var df = qs('[data-ff-discount]', scope);
      var all = ((df && df.getAttribute('data-codes')) || '').split(',').filter(Boolean);
      var rc = rm.getAttribute('data-code') || '';
      applyDiscount(all.filter(function (c) { return lower(c) !== lower(rc); }), rm, '');
    }
  }

  function onKeydown(e) {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    if (e.key === 'Escape') { if (d.querySelector('dialog[open]')) return; close(); return; }
    if (e.key !== 'Tab') return;
    var panel = qs('[data-ff-cart-panel]', d);
    if (!panel) return;
    var f = qsa('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, summary, [tabindex]:not([tabindex="-1"])', panel)
      .filter(function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0; });
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- Lieferdatum (Versand an österreichischen Werktagen) ---------- */
  var WD = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
  var WDL = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  var HOL = {};
  var TRUCK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3 3.2v2.8h-7"/><circle cx="6.5" cy="17.2" r="1.7"/><circle cx="17" cy="17.2" r="1.7"/></svg>';

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function dkey(d) { return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); }
  function plus(d, n) { return new Date(d.getTime() + n * 86400000); }
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Date.UTC(y, mo - 1, da));
  }
  function holidays(y) {
    if (HOL[y]) return HOL[y];
    var s = {};
    ['01-01', '01-06', '05-01', '08-15', '10-26', '11-01', '12-08', '12-24', '12-25', '12-26', '12-31'].forEach(function (md) { s[y + '-' + md] = 1; });
    var e = easter(y);
    [1, 39, 50, 60].forEach(function (n) { s[dkey(plus(e, n))] = 1; });
    HOL[y] = s;
    return s;
  }
  function workday(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && !holidays(d.getUTCFullYear())[dkey(d)]; }
  function nextWorkday(d) { var x = plus(d, 1); while (!workday(x)) x = plus(x, 1); return x; }
  function today() {
    try {
      var o = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Vienna', year: 'numeric', month: 'numeric', day: 'numeric' })
        .formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
      return new Date(Date.UTC(+o.year, +o.month - 1, +o.day));
    } catch (e) {
      var n = new Date();
      return new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate()));
    }
  }
  function fmt(d) { return WD[d.getUTCDay()] + ', ' + pad(d.getUTCDate()) + '.' + pad(d.getUTCMonth() + 1) + '.'; }

  function delivery() {
    var t = today();
    var ship = nextWorkday(t);
    var days = Math.round((ship - t) / 86400000);
    var from = nextWorkday(ship);
    var to = nextWorkday(nextWorkday(from));
    var word = days === 1 ? 'morgen' : (days < 7 ? 'am ' + WDL[ship.getUTCDay()] : 'am ' + fmt(ship));
    return { tomorrow: days === 1, shipWord: word, ship: fmt(ship), from: fmt(from), to: fmt(to), range: fmt(from) + ' – ' + fmt(to) };
  }

  function refreshDelivery() {
    var els = qsa('[data-ff-delivery]');
    if (!els.length) return;
    var d = delivery();
    var longShip = d.tomorrow ? 'Heute bis 24 Uhr bestellt, morgen verschickt' : 'Jetzt bestellt, ' + d.shipWord + ' verschickt';
    var cartShip = d.tomorrow ? 'Heute bestellt, morgen verschickt' : 'Jetzt bestellt, ' + d.shipWord + ' verschickt';
    var shortShip = d.tomorrow ? 'Morgen verschickt' : d.shipWord.charAt(0).toUpperCase() + d.shipWord.slice(1) + ' verschickt';
    els.forEach(function (el) {
      var av = el.getAttribute('data-ff-available'); if (av === 'false') return; if (av === 'backorder') { var bf = today(); for (var bi = 0; bi < 5; bi++) bf = nextWorkday(bf); var bt = nextWorkday(nextWorkday(bf)); var bo = TRUCK + '<span class="ff-backorder" style="color:#D9730D"><strong style="color:#D9730D">Hohe Nachfrage</strong> · Lieferzeit ca. 1 Woche<br>Lieferung ' + fmt(bf) + ' – ' + fmt(bt) + '</span>'; if (el.innerHTML !== bo) el.innerHTML = bo; return; }
      var mode = el.getAttribute('data-ff-delivery-mode') || 'cart';
      var html;
      if (mode === 'product') html = TRUCK + '<span><strong>Auf Lager</strong> · ' + longShip + '<br>Lieferung ' + d.range + ' (2–4 Werktage)</span>';
      else if (mode === 'short') html = TRUCK + '<span>' + shortShip + ' · Lieferung ab ' + d.from + '</span>';
      else html = TRUCK + '<span>' + cartShip + ' · Lieferung ' + d.range + '</span>';
      if (el.innerHTML !== html) el.innerHTML = html;
    });
  }

  /* ---------- Start ---------- */
  window.FFCRO = { open: open, close: close, add: add, refresh: refresh, notice: notice, refreshDelivery: refreshDelivery, delivery: delivery };

  function onChange(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var wc = t.closest('[data-ff-wandcheck]');
    if (wc && t.type === 'radio') {
      wc.setAttribute('data-wall', t.value);
      qsa('[data-wc-res]', wc).forEach(function (r) { r.hidden = r.getAttribute('data-wc-res') !== t.value; });
      if (t.value !== 'gips') qsa('input[data-ff-with]', wc).forEach(function (c) { c.checked = false; });
    }
  }

  window.addEventListener('submit', onSubmit, true);
  document.addEventListener('change', onChange);
  document.addEventListener('click', onClick);
  document.addEventListener('keydown', onKeydown);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  document.addEventListener('cart:update', function () {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 150);
  });

  function init() {
    var sec = document.getElementById('shopify-section-' + SECTION);
    var design = window.Shopify && window.Shopify.designMode;
    if (sec && sec.parentNode !== document.body && !design) document.body.appendChild(sec);
    refreshDelivery();
    upgradeState();
    detectCountry();
    if (/[?&]ff-cart=open\b/.test(window.location.search)) open();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/*! Fire & Flame – In-App-Browser-Hinweis + Warenkorb-Übergabe (25.10.2026)
   Facebook-/Instagram-Browser: im Warenkorb Link „Warenkorb in Safari/Chrome öffnen“.
   Der Link trägt die Artikel (ff_cart=Variante:Menge,…), Rabattcodes (ff_dc) und die UTM/fbclid der Sitzung;
   im neuen Browser legt das Skript die Artikel wieder in den Warenkorb und öffnet ihn. */
(function () {
  'use strict';
  if (window.FFIAB) return;
  window.FFIAB = true;
  var ua = navigator.userAgent || '';
  var app = /Instagram/i.test(ua) ? 'instagram' : (/FBAN|FBAV|FB_IAB|FBIOS|FB4A|FBMS|MessengerForiOS/.test(ua) ? 'facebook' : '');
  var ios = /iPhone|iPad|iPod/i.test(ua);
  var android = /Android/i.test(ua);
  var LAND = 'ffLandParams';
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'fbclid'];
  function clar(n) { try { if (typeof window.clarity === 'function') window.clarity('event', n); } catch (e) {} }
  function ss(k, v) { try { if (v === undefined) return window.sessionStorage.getItem(k); window.sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function json(r) { return r.json(); }
  function postJ(path, body) {
    return window.fetch(path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(json);
  }

  /* Landing-Parameter der Sitzung merken (für die Übergabe in den anderen Browser) */
  try {
    var q0 = new URLSearchParams(window.location.search);
    if (!ss(LAND)) {
      var keep = [];
      KEYS.forEach(function (k) { var v = q0.get(k); if (v) keep.push([k, v]); });
      if (keep.length) ss(LAND, JSON.stringify(keep));
    }
  } catch (e) {}

  /* Warenkorb aus dem Link wiederherstellen */
  function restore() {
    var p;
    try { p = new URLSearchParams(window.location.search); } catch (e) { return; }
    var raw = p.get('ff_cart');
    if (!raw) return;
    var want = raw.split(',').map(function (s) { var a = s.split(':'); return { id: parseInt(a[0], 10), q: parseInt(a[1], 10) || 1 }; })
      .filter(function (x) { return x.id > 0 && x.q > 0 && x.q < 100; }).slice(0, 30);
    var dc = (p.get('ff_dc') || '').trim();
    p.delete('ff_cart'); p.delete('ff_dc');
    var clean = window.location.pathname + (p.toString() ? '?' + p.toString() : '') + window.location.hash;
    window.fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(json).then(function (cart) {
      var have = {};
      (cart.items || []).forEach(function (i) { have[i.variant_id] = (have[i.variant_id] || 0) + i.quantity; });
      var items = want.map(function (w) { return { id: w.id, quantity: Math.max(0, w.q - (have[w.id] || 0)) }; })
        .filter(function (x) { return x.quantity > 0; });
      return items.length ? postJ('/cart/add.js', { items: items }) : null;
    }).then(function () {
      return dc ? postJ('/cart/update.js', { discount: dc }) : null;
    }).catch(function () {}).then(function () {
      try { window.history.replaceState(null, '', clean); } catch (e) {}
      clar('iab_restore');
      var onCart = /\/cart\/?$/.test(window.location.pathname);
      if (window.FFCRO && window.FFCRO.refresh) {
        window.FFCRO.refresh().then(function () { if (!onCart && window.FFCRO.open) window.FFCRO.open(); });
      } else if (onCart) {
        window.location.reload();
      }
    });
  }

  /* Im App-Browser: Warenkorb laufend in die Seitenadresse schreiben, damit „Im externen Browser öffnen“ ihn mitnimmt */
  var syncTimer = null;
  function syncUrl() {
    window.fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(json).then(function (cart) {
      var agg = {};
      (cart.items || []).forEach(function (i) { agg[i.variant_id] = (agg[i.variant_id] || 0) + i.quantity; });
      var parts = Object.keys(agg).map(function (k) { return k + ':' + agg[k]; });
      var codes = (cart.discount_codes || []).map(function (d) { return d && d.code; }).filter(Boolean);
      var p = new URLSearchParams(window.location.search);
      p.delete('ff_cart'); p.delete('ff_dc');
      if (parts.length) {
        p.set('ff_cart', parts.join(','));
        if (codes.length) p.set('ff_dc', codes.join(','));
        var land = [];
        try { land = JSON.parse(ss(LAND) || '[]'); } catch (e) { land = []; }
        land.forEach(function (kv) { if (KEYS.indexOf(kv[0]) !== -1 && !p.get(kv[0])) p.set(kv[0], kv[1]); });
        if (!p.get('utm_source')) { p.set('utm_source', app || 'inapp'); p.set('utm_medium', 'inapp_handoff'); }
      }
      var next = window.location.pathname + (p.toString() ? '?' + p.toString() : '') + window.location.hash;
      if (next !== window.location.pathname + window.location.search + window.location.hash) {
        try { window.history.replaceState(window.history.state, '', next); } catch (e) {}
      }
    }).catch(function () {});
  }
  function queueSync() { window.clearTimeout(syncTimer); syncTimer = window.setTimeout(syncUrl, 300); }

  function init() {
    if (!app) { restore(); return; }
    if (!(ios || android)) return;
    var h = document.documentElement;
    h.classList.add('ff-iab');
    h.setAttribute('data-ff-iab-os', ios ? 'ios' : 'android');
    h.setAttribute('data-ff-iab-app', app);
    try { if (typeof window.clarity === 'function') window.clarity('set', 'inapp', app); } catch (e) {}
    syncUrl();
    document.addEventListener('cart:updated', queueSync);
    window.addEventListener('pageshow', function (e) { if (e.persisted) queueSync(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
